import { BLOCK_TYPES } from "../../common";
import { isValidCallbackDragArrangeList } from "../DragArrangeList";

const { SCRATCH_ARRANGE_LIST_BLOCK } = BLOCK_TYPES;

const isValidCallback = (props: any) =>
    isValidCallbackDragArrangeList({
        ...props,
        blockType: SCRATCH_ARRANGE_LIST_BLOCK,
    });

export default isValidCallback;
